import { useQuery } from "@tanstack/react-query";
import { z } from "zod";

import { useDeploymentType } from "~/shared/hooks/use-deployment-type.ts";
import { useFeatureFlagGate } from "~/shared/hooks/use-feature-flag-gate.ts";
import { apiRoutes } from "~/shared/services/api/api-routes.ts";
import { getAndValidate } from "~/shared/services/api/fetch-client.ts";

const UnprocessedBulkQuotesSchema = z.number().or(z.string().transform(Number));

export const useUnprocessedBulkQuotes = () => {
	const { isInternal } = useDeploymentType();
	const { isEnabled: isBulkUploadEnabled } =
		useFeatureFlagGate("traxLtlBulkUpload");

	return useQuery({
		queryKey: ["unprocessed-bulk-quotes"],
		queryFn: async () => {
			const result = await getAndValidate(
				apiRoutes.CUSTOMER_UNPROCESSED_BULK,
				UnprocessedBulkQuotesSchema,
			);
			if (!result.success) {
				throw new Error("Failed to fetch unprocessed bulk quotes");
			}
			return result.data;
		},
		enabled: !isInternal && isBulkUploadEnabled,
		refetchOnMount: "always",
	});
};
